import { Domains } from '../../constants';
import { BaseAuthedTracker } from './baseTracker';

const TIME_SLIDER_OPENED_EVENT = '[Time Slider] Opened';
const TIME_SLIDER_CLOSED_EVENT = '[Time Slider] Closed';
const TIME_SLIDER_CHANGED_EVENT = '[Time Slider] Changed';
const TIME_SLIDER_VALUE_APPLIED_EVENT = '[Time Slider] Value Applied';

export class TimeSliderTracker {
  constructor(
    readonly tracker: BaseAuthedTracker,
    readonly domain: Domains
  ) {}
  /**
   * Call this when user open TimeSlider
   */
  public trackTimeSliderOpen = (actionData: any = {}) => {
    this.tracker.track(TIME_SLIDER_OPENED_EVENT, this.domain, actionData);
  };

  /**
   * Call this when user hide TimeSlider
   */
  public trackTimeSliderClose = (actionData: any = {}) => {
    this.tracker.track(TIME_SLIDER_CLOSED_EVENT, this.domain, actionData);
  };

  /**
   * Call this when user changes TimeSlider
   */
  public trackTimeSliderChange = (actionData: any = {}) => {
    this.tracker.track(TIME_SLIDER_CHANGED_EVENT, this.domain, {
      ...actionData,
    });
  };

  /**
   * Call this when user applies TimeSlider
   */
  public trackTimeSliderValueApply = (
    timeSliderValues: any,
    actionData: any = {}
  ) => {
    this.tracker.track(TIME_SLIDER_VALUE_APPLIED_EVENT, this.domain, {
      ...actionData,
      timeSliderValues,
    });
  };
}
